const type = 'SET_ACCOUNT_STATUSES';

const setAccountStatuses = (data) => ({
  type,
  data,
});

export { type };
export default setAccountStatuses;
